import { render, staticRenderFns } from "./OpenSessionComponent.vue?vue&type=template&id=2542e378&scoped=true&"
import script from "./OpenSessionComponent.vue?vue&type=script&lang=ts&"
export * from "./OpenSessionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2542e378",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
installComponents(component, {VFlex})
